import { useIntl } from 'react-intl';
import styles from './ProblemSolutionSection.module.css';
import ContourBackdrop from '../../../../components/ContourBackdrop/ContourBackdrop';
import Group1 from '../../../../shared/assets/home/Group 15.png';
import Group2 from '../../../../shared/assets/home/Group 16.png';
import Group3 from '../../../../shared/assets/home/Group 17.png';

const ProblemSolutionSection = () => {
	const intl = useIntl();

	const problems = [
		{
			id: 1,
			icon: Group3,
			title: intl.formatMessage({ id: 'Problem&SolutionId3' }),
			text: intl.formatMessage({ id: 'Problem&SolutionId4' }),
		},
		{
			id: 2,
			icon: Group2,
			title: intl.formatMessage({ id: 'Problem&SolutionId7' }),
			text: intl.formatMessage({ id: 'Problem&SolutionId8' }),
		},
		{
			id: 3,
			icon: Group1,
			title: intl.formatMessage({ id: 'Problem&SolutionId5' }),
			text: intl.formatMessage({ id: 'Problem&SolutionId6' }),
		},
	];

	return (
		<section className={styles.section}>
			<ContourBackdrop className={styles.contours} rings={7} from={3.4} />

			<div className={styles.header}>
				<h2 className={styles.title}>
					{intl.formatMessage({ id: 'Problem&SolutionId2' })}
				</h2>
				<p className={styles.subtitle}>
					{intl.formatMessage({ id: 'Problem&SolutionId1' })}
				</p>
			</div>

			<div className={styles.cards}>
				{problems.map(problem => (
					<article key={problem.id} className={styles.card}>
						<h3 className={styles.cardTitle}>{problem.title}</h3>
						<div className={styles.cardIcon}>
							<img src={problem.icon} alt='' />
						</div>
						<p className={styles.cardText}>{problem.text}</p>
					</article>
				))}
			</div>
		</section>
	);
};

export default ProblemSolutionSection;
